import { render, staticRenderFns } from "./CreateUserContainer.vue?vue&type=template&id=18f2e5c8&scoped=true"
import script from "./CreateUserContainer.vue?vue&type=script&lang=js"
export * from "./CreateUserContainer.vue?vue&type=script&lang=js"
import style0 from "./CreateUserContainer.vue?vue&type=style&index=0&id=18f2e5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2e5c8",
  null
  
)

export default component.exports